export default {
  'show-list': 'Lista',
  'show-map': 'Mappa',
  'details': 'Dettagli',
  'route-link': 'Percorso',
  'route-link.detail': 'Calcola percorsoe',
  'map': 'Mappa',
  'has-boxes': 'Vendita di imballi Hermess',
  'acceptsSuitcases': 'Consegna bagagli',
  'back': 'indietro',

  'shoplist.info': {
    __html: 'Immettere in alto un CAP, una località e/o una via nel cui circondario deve iniziare la ricerca.'
  },

  'shoplist.no-reroute-shops': 'Non ci sono Parcel Shop vicini alla località cercata.',

  'business-hours.unknown': 'non sono disponibili orari di apertura per questo Parcel Shop.',
  'business-hours.closed': 'Chiuso',

  'search': 'Ricerca',
  'search.input-placeholder': 'Immettere indirizzo, CAP o località',
  'search-criteria': 'Criteri di ricerca',
  'search.toggle-details': 'Ricerca dettagliata',
  'search-detail.intro': 'I Parcel Shop visualizzati possono essere circoscritti secondo i criteri seguenti:',
  'search-detail.luggage.label': 'Consegna bagagli',
  'search-detail.boxes.label': 'Vendita di imballi Hermes',
  'search-detail.apply': 'Applica filtro',
  'search-detail.close': 'Chiudi',

  'error.no-shops': {
    __html: 'Non ci sono Parcel Shop vicini alla località cercata.'
  },

  'error.address-resolve-failed': 'L\'indirizzo inserito è sconosciuto. Per favore modifica la tua ricerca.',
  'error.position-resolve-failed': 'L\'indirizzo inserito è sconosciuto. Per favore modifica la tua ricerca.',

  'days.short.MON': 'Lun',
  'days.short.TUE': 'Mar',
  'days.short.WED': 'Mer',
  'days.short.THU': 'Gio',
  'days.short.FRI': 'Ven',
  'days.short.SAT': 'Sab',
  'days.short.SUN': 'Dom',
  'days.full.MON': 'Lunedì',
  'days.full.TUE': 'Martedì',
  'days.full.WED': 'Mercoledì',
  'days.full.THU': 'Giovedì',
  'days.full.FRI': 'Venerdì',
  'days.full.SAT': 'Sabato',
  'days.full.SUN': 'Domenica',
  'days.today': 'Oggi',
  'days.tomorrow': 'Domani',

  'time.preposition.UNTIL': 'fino alle',
  'time.preposition.BEFORE': 'prima delle',

  //paketParcelLock
  'search.paketParcelLock.note': 'Please note: ',
  'search.paketParcelLock.link-text': 'how it works',
  'search.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  //paketParcelLock
  'details.benefits.paketParcelLock.list-1': 'Sending of parcels',
  'details.benefits.paketParcelLock.list-2': 'Online shop returns',
  'details.benefits.paketParcelLock.list-3': 'Send parcels fast and easy',
  'details.benefits.paketParcelLock.link-wrapper-text': 'For more Information please see ',
  'details.benefits.paketParcelLock.link-text': 'www.hamburgbox.de/faq',
  'details.benefits.paketParcelLock.link-url': 'http://www.hamburgbox.de/faq',

  //paketParcelLock
  'details.hint.paketParcelLock.headline': 'Important note:',
  'details.hint.paketParcelLock.copy': 'To be able to use this parcel station, a TAN is required to pick up the shipment.',
  'details.hint.paketParcelLock.link-text': ' How it works',
  'details.hint.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  // Media markkt
  'details.hint.parcel-shop.media-markt.copy': 'In questo punto pacchi Hermes è possibile consegnare solo le spedizioni private con un bollettino di spedizione pagato online (tramite myHermes.de o tramite l’app Hermes).',

  //paketParcelLock
  'callback-button.paketParcelLock.text': 'Select Paketstation',

  //paketParcelLock
  'details.title.paketParcelLock': 'Paketstation',

  'details.title': 'Parcel Shop Hermes',
  'details.opening-hours': 'Orari di apertura:',
  'details.opening-hours-today': 'Orari di apertura odierni',
  'details.parcelShopNumber': 'ID Parcel Shop',

  'details.benefits.shipping': 'Spedizione di pacchetti e pacchi',
  'details.benefits.paketfuxx': 'Consengna a vicinato',
  'details.benefits.redirect': 'Indirizzo di recapito alternativo',
  'details.benefits.pickup': 'Ritiro con delega',
  'details.benefits.retours': 'Restituzione di resi del negozio online',

  'details.on-holiday.note': 'Nota bene:',
  'details.on-holiday': 'Il nostro Parcel Shop sarà chiuso dal %from al %to.',
  'details.on-holiday.short': 'Ferie: %from – %to',
  'services': 'Servizi',
  'callback-button.text': 'Accetta Parcel Shop',
  'callback-button.unavailable': 'Questo Parcel Shop non è purtroppo selezionabile quale Parcel Shop desiderato.',

  'filter.luggage': 'Consegna bagagli',
  'filter.boxes': 'Vendita di imballi Hermes',
  'filter.time': 'Aperto $day %time',

  'time-filter.closed': 'Apre alle ',
  'time-filter.opened': 'Aperto fino alle ',
  'time-filter.from': ' e dalle ',
  'time-filter.openedNextDay': 'Apre il lunedì ',
  'time-filter.at': 'alle',
  'time-filter.openedFilter': 'Aperto ',

  'time-filter.openToday': 'Open today: ',
  'time-filter.clock': ' Ora',

  'social-buttons.facebook': 'condividi',
  'social-buttons.twitter': 'tweet',
  'social-buttons.whatsapp': 'condividi',
  'social-buttons.email': 'mail',
  'social-buttons.print': 'stampa',

  'shop-list.title': 'I Parcel Shop della tua zona',
  'widget.headline': 'Cerca Parcel Shop',
  'widget.input-placeholder': 'Indirizzo, CAP, luogo',
  'widget.option-button': 'Altre opzioni',
  'widget.submit-button': 'Cerca',
  'widget.open-on': 'Aperto il',

  'legal': 'Informazioni legali',
  'security': 'Note sulla sicurezza',
  'privacy': 'Privacy',
  'cookies': 'Cookies',

  'legal.url': 'https://www.hermesworld.com/int/credits/',
  'security.url': 'https://www.hermesworld.com/int/security-advice/',
  'privacy.url': 'https://www.hermesworld.com/int/data-protection/',
  'cookies.url': '#uc-corner-modal-show',

  'cookie.text': 'This website uses cookies to analyse our traffic.',
  'cookie.button-text': 'Ok',
  'cookie.link-text': 'Learn more',
  'cookie.link-url': 'https://www.hermesworld.com/int/data-protection/',

  //UserCentrics Cookie Consent
  'usercentrics.info': 'Die Anzeige von PaketShops in der Nähe basiert auf Google Maps. Mit dem Klick auf "Karte aktivieren" stimme ich der Datenfreigabe an Google Maps zu.',
  'usercentrics.button': 'Karte aktivieren',
  'usercentrics.privacy-text': 'Datenschutz',
  'usercentrics.privacy-url': 'https://www.myhermes.de/datenschutz/',
  'usercentrics.impressum-text': 'Impressum',
  'usercentrics.impressum-url': 'https://www.myhermes.de/impressum/'
};
